import { useState, useEffect } from "react";
import "./ViewWork.css";

const ViewWork = ({ service, onBack }) => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const images = service.images;

  useEffect(() => {
    document.body.style.overflow = "hidden";
    document.body.classList.add("viewwork-open");
    const t = setTimeout(() => setVisible(true), 20);
    return () => {
      clearTimeout(t);
      document.body.style.overflow = "auto";
      document.body.classList.remove("viewwork-open");
    };
  }, []);

  const prev = () => setCurrentImageIndex((p) => (p - 1 + images.length) % images.length);
  const next = () => setCurrentImageIndex((p) => (p + 1) % images.length);

  return (
    <div
      className={`vw-root ${visible ? "vw-visible" : ""}`}
      style={{ backgroundImage: `url(${images[currentImageIndex]})` }}
    >
      <div className="vw-overlay" />

      {/* ── Back button ── */}
      <button className="vw-back" onClick={onBack}>
        <span className="vw-back-arrow">←</span>
        <span className="vw-back-label">Back</span>
      </button>

      {/* ── Counter ── */}
      <div className="vw-counter">
        {String(currentImageIndex + 1).padStart(2, "0")} /&nbsp;
        {String(images.length).padStart(2, "0")}
      </div>

      {/* ── Side nav arrows ── */}
      {images.length > 1 && (
        <>
          <button className="vw-side-nav vw-side-nav--left" onClick={prev}>‹</button>
          <button className="vw-side-nav vw-side-nav--right" onClick={next}>›</button>
        </>
      )}

      {/* ── Bottom text ── */}
      <div className="vw-bottom">
        <div className="vw-text">
          <h2 className="vw-title">{service.title}</h2>
          <p className="vw-desc">{service.description}</p>
        </div>
      </div>

    </div>
  );
};

export default ViewWork;